<template>
    <span>
        <q-spinner-puff v-if="params.value === undefined"></q-spinner-puff>
        <template v-else>
            <v-button v-show="!context.isTrash" :disable="context.isLoading" color="info"
                      class="no-shadow on-left"
                      icon="edit" @click.prevent="context.methods.editRow(params.data.id)" size="sm" round dense/>
            <v-button v-show="!context.isTrash" :disable="context.isLoading" color="negative" class="no-shadow"
                      icon="delete" size="sm" round dense>
                <q-popover>
                    <div class="group text-center">
                        <p><strong>{{ context.messages['are you sure?'] }}</strong></p>
                        <v-button class="no-shadow capitalize" color="negative" no-caps icon="delete"
                                  @click="context.methods.deleteRow(params.data.id)" v-close-overlay>
                            {{ context.messages['delete'] }}
                        </v-button>
                        <v-button class="no-shadow capitalize" color="faded" no-caps v-close-overlay>
                            {{ context.messages['cancel'] }}
                        </v-button>
                    </div>
                </q-popover>
            </v-button>
            <v-button v-show="context.isTrash" :disable="context.isLoading" color="faded" class="no-shadow"
                      icon="restore page" @click.prevent="context.methods.restoreRow(params.data.id)" small round flat
                      dense/>
            <v-button v-show="context.isTrash" :disable="context.isLoading" color="faded" class="no-shadow"
                      icon="delete forever"
                      small round flat>
                <q-popover>
                    <div class="group text-center">
                        <p><strong>{{ context.messages['are you sure?'] }}</strong></p>
                        <v-button class="no-shadow capitalize" color="negative" no-caps icon="delete"
                                  @click="context.methods.deleteRowForever(params.data.id)" v-close-overlay>
                            {{ context.messages['delete forever'] }}
                        </v-button>
                        <v-button class="no-shadow capitalize" color="faded" no-caps v-close-overlay>
                            {{ context.messages['cancel'] }}
                        </v-button>
                    </div>
                </q-popover>
            </v-button>
        </template>
    </span>
</template>

<script>
    import {
        QPopover,
        QSpinnerPuff
    } from 'quasar-framework'

    import Vue from 'vue'

    export default Vue.extend({
        components: {
            QPopover,
            QSpinnerPuff
        },
        computed: {
            context() {
                return this.params.context
            }
        }
    })
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/ListButtons.vue